
import * as MUTATIONS from '../../../state/mutations/User';
import ActionBar from '../../../components/ActionBar/NewActionBar';
import Images from '../../../state/stores/Image/images';
import React from 'react';
import { BasicModal } from '../../../components/Modal/BasicModal';
import { H3, ParagraphSBold, mainTypoRegular } from '../../../config/designSystem/typography';
import {Image, KeyboardAvoidingView, StyleSheet, TextInput,  View} from 'react-native';
import { TwoButtonsHorizontal } from '../../../components/Button/TwoButtonsHorizontal';
import { assistanceKey, settingKey } from '../../../constants/routeKeys';
import { concatPath } from '../../../utils/links/concatPath';
import { isIos } from '../../../config/designSystem/Layout';
import { router, useSegments } from 'expo-router';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { useKeyboardVisible } from '../../../hooks/ui/useKeyboardVisible';
import { useMutation } from '@apollo/client';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useState } from 'react';
import { useStores } from '../../../hooks/useStores';


export default function HelpDesk() {
  const [message, setMessage] = useState('');
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;
  const [modalThanksFeedbackVisibility, setModalThanksFeedbackVisibility] = React.useState(false);
  const [feedbackWithJson] = useMutation( MUTATIONS.FEEDBACK_WITH_JSON );
  const {width, height} = useAvailableDimensions();
  const segment = useSegments();

  const isKeyboardVisible = useKeyboardVisible();
  const isSmall = useBreakpoint().sm;



  const onSubmit= () => {
    feedbackWithJson({variables:
      {feedback:
        JSON.stringify({
          'message':message
        })
      }});
    setModalThanksFeedbackVisibility(true);
    setMessage('');
  };

  const endOfHelpDesk = () => {
    if (segment.includes('(Setting)')) {
      router.navigate(concatPath([settingKey],0) as string);
    } else {
      router.navigate(concatPath([assistanceKey],0) as string);
    }

  };
  const insets = useSafeAreaInsets();
  const MAX_WIDTH = !isSmall?Math.max(800,width*0.6):width;

  return (
    <>
      <ActionBar
        width='100%'
        height={40}
        // This stack sets headerShown:false, so nothing above provides the top
        // inset and the back button rendered on top of the status bar clock.
        marginTopPhone={insets.top}
        title={labels?.TITLE_HELP_DESK}
        onExit={()=> {}}
        onPrevious={endOfHelpDesk}
        hideExit={true}
      />

      {/* 'padding', not 'height': with 'height' the view shrank a second time when
          the app came back from the background with the keyboard up, and the
          buttons (then absolutely positioned at its bottom) landed on the field.
          The buttons are now in the normal flow, under a content block that
          takes the free space. Android pans (softwareKeyboardLayoutMode). */}
      <KeyboardAvoidingView behavior={isIos ? 'padding' : undefined} style={{flex:1, alignItems:'center'}}>
        {<BasicModal isVisible={modalThanksFeedbackVisibility} onDismiss={() => {setModalThanksFeedbackVisibility(false);
          {
            endOfHelpDesk();
          }
        }}
        mainText={labels?.FEEDBACK_THANKS_MAIN_TEXT} buttonText={labels?.FEEDBACK_THANKS_BUTTON}/>}

        <View style={[{flexDirection:'column', alignItems:'center', rowGap: !isSmall?50:height/50, marginTop: 10, width:0.8*width, maxWidth:MAX_WIDTH}, isSmall && {flex: 1}]}>
          {isSmall && (
            <Image source={Images.assistance.helpdesk} resizeMode="cover" style={{position:'absolute', margin:10}}/>
          )}
          <H3>{labels?.HELP_DESK_CONTENT}</H3>
          <ParagraphSBold>{labels?.HELP_DESK_TEXT}</ParagraphSBold>

          {/* Write feedback field  wrapper like the modal */}
          <View style={[style.input,style.shadowProp, isSmall && {width: 0.8*width, maxHeight: 0.25
            *height}, !isSmall && {width:'80%'}]}>
            <TextInput autoFocus={true} style={{paddingHorizontal:10, marginVertical: 10, height:Math.max(30, Math.min(100,0.1*height)), fontFamily:mainTypoRegular}}
              placeholder={labels?.HELP_DESK_PLACEHOLDER}
              value={message}
              multiline={true}
              numberOfLines={5}
              onChangeText={text => setMessage(text)}
              returnKeyType="done"
              onSubmitEditing={onSubmit}
            />

          </View>
        </View>
        {/* Cancel and send feedback buttons */}
        <View style={[style.buttonContainerBasic, isSmall && isKeyboardVisible && style.buttonContainerAboveKeyboard,
          !isSmall && {marginTop: 50}]}>
          <TwoButtonsHorizontal
            onPressLeft={endOfHelpDesk}
            onPressRight={onSubmit}
            labelLeft={labels?.HELP_DESK_BUTTON}
            labelRight={labels?.HELP_DESK_BUTTON2}
            paddingVertical={15}
            width={MAX_WIDTH}
            smallText={true}
          />
        </View>

      </KeyboardAvoidingView>
    </>


  );
}


// Styling of the elements
const style = StyleSheet.create({

  input: {
    paddingHorizontal:10,
    borderColor:'#C8C8C8',
    borderWidth:1,
    backgroundColor: 'white',
    borderRadius: 10
  },
  shadowProp: {
    shadowColor: '#171717',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.2,
    shadowRadius: 3,
    elevation: 3
  },

  //  Buttons style
  buttonContainerAboveKeyboard: {
    marginBottom: 20,
  },
  buttonContainerBasic: {
    marginTop:10,
    flexDirection: 'row',

  },
  buttonStyleWeb:{
    borderRadius:10,

  }
});

